import React from 'react';
import { useTranslation } from 'react-i18next';
import { PageTitle } from '../../../shared/Typography/PageTitle';
import { ProfileContent } from '../../../profile/ProfileContent';
import { AddressesContent } from '../../../profile/AddressesContent';
import { Alert, Typography } from '@mui/material';
import { isNullOrUndefined } from '../../../../utils/utils';
import { formatPrice } from '../../../../utils/numberFormatter';
import useInvoices from '../../../../hooks/invoices/useInvoices';
import { MyCompany } from '../../../profile/MyCompany';

export const Profile: React.FC = () => {
    const { t } = useTranslation();
    const balance = useInvoices();

    const { balances } = balance.useInvoicesBalanceSWR();

    return (
        <>
            {!isNullOrUndefined(balances) &&
                !isNullOrUndefined(balances.overDueBalance) &&
                balances.overDueBalance != 0 && (
                    <Alert
                        variant="filled"
                        severity="warning"
                        sx={{ marginBottom: '10px' }}
                    >
                        <Typography gutterBottom>
                            {t('PROFILE.OVER_DUE_BALANCE', {
                                number:
                                    formatPrice(
                                        Number(balances.overDueBalance)
                                    ) + ' Ft',
                            })}
                        </Typography>
                    </Alert>
                )}
            <PageTitle>{t('PROFILE.PAGE_TITLE').toString()}</PageTitle>
            <ProfileContent />
            <AddressesContent />
            <MyCompany />
        </>
    );
};
